import { gql } from '@apollo/client';
import { Boolean, ObjectID } from '../../queries';
import { MutationMessage } from '../update-list-trading-real-estates';

export interface MarkNotificationsAsReadData {
  markNotificationsAsRead?: MutationMessage;
}
export interface MarkNotificationsAsReadVariables {
  notificationIds?: ObjectID[];
  isReadAll?: Boolean;
}

export const MARK_NOTIFICATIONS_AS_READ = gql`
  mutation markNotificationsAsRead($notificationIds: [ObjectID], $isReadAll: Boolean)
  @api(name: common) {
    markNotificationsAsRead(notificationIds: $notificationIds, isReadAll: $isReadAll) {
      msg
      success
    }
  }
`;
